export const sortDocuments = (documents) =>
	documents.sort(
		(docA, docB) =>
			new Date(docA.created_at).getTime() - new Date(docB.created_at).getTime(),
	);
